__webpack_public_path__ = window.app.static_url; // eslint-disable-line no-undef

import 'what-input';

import {Context} from 'pacto';
import {Action as Background} from 'modules/generic/background/actions/InitializeLazy';
import {Action as Overlay} from 'modules/generic/overlay/actions/InitializeLazy';
import {Action as Picture} from 'modules/generic/picture/actions/InitializeLazy';
import {Action as Schemeable} from 'modules/generic/schemeable/actions/InitializeLazy';
import {Action as Sharing} from 'modules/generic/sharing/actions/InitializeLazy';
import {Action as Video} from 'modules/generic/video/actions/InitializeLazy';
import {Action as Vimeoplayer} from 'modules/generic/vimeoplayer/actions/Initialize';

import {Action as Cookiedisclaimer} from 'modules/base/cookiedisclaimer/actions/Initialize';
import {Action as Navigation} from 'modules/base/navigation/actions/Initialize';
import {Action as ScrollAnimation} from './modules/base/scroll-animations/actions/Initialize';

import {Action as Accordion} from 'modules/cms/accordion/actions/InitializeLazy';
import {Action as Anchors} from 'modules/cms/anchors/actions/InitializeLazy';
import {Action as Clients} from 'modules/cms/clients/actions/InitializeLazy';
import {Action as ClientsAnimated} from 'modules/cms/clients-animated/actions/InitializeLazy';
import {Action as ContactForm} from 'modules/cms/contact-form/actions/InitializeLazy';
import {Action as WhitepaperForm} from 'modules/cms/whitepaper-form/actions/InitializeLazy';
import {Action as Devices} from 'modules/cms/devices/actions/InitializeLazy';
import {Action as Intro} from 'modules/cms/intro/actions/InitializeLazy';
import {Action as Slideshow} from 'modules/cms/slideshow/actions/InitializeLazy';
import {Action as Factcards} from 'modules/cms/factcards/actions/InitializeLazy';
import {Action as Services} from 'modules/cms/services/actions/InitializeLazy';
import {Action as Table} from 'modules/cms/table/actions/Initialize';
import {Action as Teaser} from 'modules/cms/teaser/actions/InitializeLazy';
import {Action as Image} from 'modules/cms/image/actions/InitializeLazy';
import {Action as AnalyticsTracking} from 'modules/tracking/analytics/actions/InitializeLazy';


const context = new Context({history: true});

context.actions.add('app:init', [
	Cookiedisclaimer,

	// Generic modules:
	Background,
	Overlay,
	Picture,
	Schemeable,
	Sharing,
	Video,
	Vimeoplayer,

	// Base modules:
	Navigation,
	ScrollAnimation,

	// CMS modules:
	Accordion,
	Anchors,
	Clients,
	ClientsAnimated,
	ContactForm,
	WhitepaperForm,
	Devices,
	Intro,
	Slideshow,
	Factcards,
	Services,
	Table,
	Teaser,
	Image,

	// Tracking modules:
	AnalyticsTracking
]);

// Remove old service worker
if ('serviceWorker' in navigator) {
	navigator.serviceWorker.getRegistrations().then((registrations) => {
		for (const registration of registrations) {
			registration.unregister();
		}
	});
}

// Calculate scrollbar width
document.body.style.setProperty('--scrollbarWidth', `${window.innerWidth - document.body.clientWidth}px`);

context.trigger('app:init', {root: document});

// This is necessary since we want to report
// failed initializations of the app to sentry
context.on('app:init:error', (event) => {
	if (!window.onerror) {
		return;
	}

	const
		error = event.data.error ?? new Error('Failed to initialize the app.')
	;

	window.onerror(error.message, window.location.href, 0, 0, error);
});

window.app.context = context;
